import { useState } from 'react';

import { RiDeleteBinLine, RiMore2Fill, RiPencilLine } from '@remixicon/react';

import { ButtonIcon, Menu, MenuItem, MenuTrigger } from '@backstage/ui';

import { AttachmentFragment } from '@spotify/confidence-graphql';

import { isRenamableArtifact } from '../../artifactUtils';
import { RenameArtifactDialog } from './RenameArtifactDialog';

interface ArtifactActionsMenuProps {
  artifact: AttachmentFragment;
  resolvedDisplayName?: string;
  onDelete: () => void;
}

export const ArtifactActionsMenu = ({
  artifact,
  resolvedDisplayName,
  onDelete,
}: ArtifactActionsMenuProps) => {
  const [renameOpen, setRenameOpen] = useState(false);
  const renamable = isRenamableArtifact(artifact);

  return (
    <>
      <MenuTrigger>
        <ButtonIcon
          variant="tertiary"
          size="small"
          icon={<RiMore2Fill size={16} />}
          aria-label="Artifact actions"
        />
        <Menu placement="bottom end">
          {renamable && (
            <MenuItem
              iconStart={<RiPencilLine />}
              onAction={() => setRenameOpen(true)}
            >
              Rename
            </MenuItem>
          )}
          <MenuItem
            color="danger"
            iconStart={<RiDeleteBinLine />}
            onAction={onDelete}
          >
            Delete
          </MenuItem>
        </Menu>
      </MenuTrigger>
      {renamable && (
        <RenameArtifactDialog
          artifact={artifact}
          resolvedDisplayName={resolvedDisplayName}
          open={renameOpen}
          onOpenChange={setRenameOpen}
        />
      )}
    </>
  );
};
